import Vue from 'vue'
import Router from 'vue-router'
import Matrix from '@/matrix/views/Matrix'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: document.querySelector('#path').value,
	routes: [
		{
			path: '*',
			redirect: '/'
		},
		{
			path: '/',
			name: 'public',
			component: Matrix
		}
	]
})